import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import { Toaster } from "sonner";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Landing />} />
                </Routes>
            </BrowserRouter>
            <Toaster
                theme="dark"
                position="bottom-right"
                toastOptions={{
                    style: {
                        background: "#0a0a0c",
                        border: "1px solid rgba(214,181,113,0.3)",
                        color: "#FCFCFC",
                        borderRadius: "0px",
                        fontFamily: "'Outfit', sans-serif",
                    },
                }}
            />
        </div>
    );
}

export default App;
